<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">&copy; {{ year }} Bitwarden Inc.</div>
  <div bitTypography="body2">{{ version }}</div>
</footer>